export const employeeListHeaders = [{
  text: 'Versendet',
  value: 'isSent',
},
{
  text: 'Benutzername',
  value: 'username',
},
{
  text: 'E-Mail-Adresse',
  value: 'email',
},
{
  text: 'Vorname',
  value: 'firstname',
},
{
  text: 'Nachname',
  value: 'surname',
},
{
  text: 'Aktiv',
  value: 'isActive',
},
{
  text: 'Gelöscht',
  value: 'isDelete',
},
{
  text: 'Aktionen',
  value: '',
  sortable: false,
},
];
